import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Glyphicon, FormGroup, ControlLabel, HelpBlock, Button, Row, Col, FormControl } from 'react-bootstrap';
import { PageHeader, PageHeaderRight } from '../shared/PageHeader';
import { Redirect, Prompt } from 'react-router-dom';
import { BsTimePickerFormControl, BsValidation } from '../shared/bsHelper';
import { EditState } from '../shared/enums';
import ToggleButton from 'react-toggle-button';
import { ModalOKCancel } from '../shared/modals';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { GroupDropdown } from '../OrderGuide/GroupDropdown';
import { BlankOrderGuideGroup } from '../shared/consts';

// https://github.com/fkhadra/react-toastify
import { toast } from 'react-toastify';

class OrderGuideGroup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            responseStatus: 200,
            editState: EditState.Edit,
            orderGuideGroup: BlankOrderGuideGroup,
            orderGuideGroupId: undefined,
            unassignedSalesReps: [],
            assignedSalesReps: [],
            unassignedStores: [],
            assignedStores: [],
            redirectToHome: false,
            showDeleteModal: false,
            errorResult: undefined,
            isDirtySettings: false,
            isDirtyStores: false,
            isDirtySalesReps: false
        };
    }

    componentDidMount = async () => {
        this.setState({ loading: true });
        try {
            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/fullsettings', fetchConfig);
            if (response.ok) {
                let data = await response.json();

                this.setState({
                    orderGuideGroup: data.orderGuideGroup,
                    orderGuideGroupId: data.orderGuideGroup.orderGuideGroupId,
                    assignedSalesReps: data.assignedSalesReps,
                    unassignedSalesReps: data.unassignedSalesReps,
                    assignedStores: data.assignedStores,
                    unassignedStores: data.unassignedStores,
                    loading: false,
                    editState: EditState.Edit,
                    isDirtySettings: false,
                    isDirtySalesReps: false,
                    isDirtyStores: false
                });
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else {
                toast.error(`Error fetching order guide group.`);
                console.log(`Error fetching order guide group: ${await response.text()}.`);
                this.setState({ redirectToHome: true });
            }

        } catch (e) {
            console.log(`Error fetching order guide group: ${e}`);
        }
    }

    saveDetails = async (e) => {
        this.clearValidationState();

        let saveJson = JSON.stringify(this.state.orderGuideGroup);
        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: saveJson
        };

        let url = `api/OrderGuideGroups/settings`;
        if (this.state.editState === EditState.Add) {
            fetchConfig.method = 'POST';
            url = `api/OrderGuideGroups/add`; // just adds foundation w/ settings
        }

        const response = await fetch(url, fetchConfig);
        let responseCopy = response.clone();
        try {
            if (response.ok) {
                let data = await response.json();
                let msg = "Settings Saved";
                if (this.state.editState === EditState.Add) {
                    msg = `Created Order Guide Group ${this.state.orderGuideGroup.orderGuideGroupName}.`;
                }
                toast.success(msg);
                // update state
                if (this.state.editState === EditState.Add) {
                    // Switch token to newly created group
                    const fetchConfig2 = {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('token')}`,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    };
                    const response2 = await fetch('api/Token/ChangeOrderGuideGroupClaim?orderGuideGroupId=' +
                        data.newOrderGuideGroup.orderGuideGroupId, fetchConfig2);
                    if (response2.ok) {
                        const auth = await response2.json();
                        localStorage.setItem('user', JSON.stringify(auth.user));
                        localStorage.setItem('token', auth.token);
                    }
                    else {
                        // added but cannot switch, just log them off
                        toast.error("Error switching to newly added Order Guide Group.");
                    }

                    // if this is an add then we will get back a list of stores and salesreps
                    this.setState({
                        editState: EditState.Edit,
                        isDirtySettings: false,
                        orderGuideGroup: data.newOrderGuideGroup,
                        assignedSalesReps: data.assignedSalesReps,
                        unassignedSalesReps: data.unassignedSalesReps,
                        assignedStores: [],
                        unassignedStores: data.unassignedStores
                    });
                }
                else { // Edit response is different
                    this.setState({
                        orderGuideGroup: data,
                        isDirtySettings: false
                    });
                }
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else { // 400
                this.setState({ errorResult: response.text() });

                var err = await responseCopy.text();
                var errMessage = JSON.parse(err);
               
                toast.warn((errMessage.errors[0].key + ": " + errMessage.errors[0].errorMessage ) || "Invalid data.");
            }
        }
        catch (e) {
            // if json() throws exception then response is left locked, so use responseCopy
            console.log(`Error saving order guide group: ${await responseCopy.text()}.`);
            console.log(e);
        }
    }

    saveSalesReps = async (e) => {
        this.clearValidationState();

        let saveJson = JSON.stringify(this.state.assignedSalesReps);

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: saveJson
        };

        let url = 'api/OrderGuideGroups/salesreps';
        const response = await fetch(url, fetchConfig);
        let responseCopy = response.clone();
        try {
            if (response.ok) {
                toast.success("Sales Rep Assignments saved.");
                this.setState({ isDirtySalesReps: false });
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else if (response.status === 400) {
                this.setState({ errorResult: await response.json() });
                toast.warn(this.state.errorResult.errorSummary || "Invalid data.");
            }
        }
        catch (e) {
            // if json() throws exception then response is left locked, so use responseCopy
            console.log('Error saving sales reps: ' + await responseCopy.text());
            console.log(e);
        }
    }

    saveStores = async (e) => {
        this.clearValidationState();

        let saveJson = JSON.stringify(this.state.assignedStores);

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            body: saveJson
        };

        let url = 'api/OrderGuideGroups/stores';
        const response = await fetch(url, fetchConfig);
        let responseCopy = response.clone();
        try {
            if (response.ok) {
                toast.success("Store Assignments saved.");
                this.setState({ isDirtyStores: false });
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else if (response.status === 400) {
                this.setState({ errorResult: await response.json() });
                toast.warn(this.state.errorResult.errorSummary || "Invalid data.");
            }
        }
        catch (e) {
            // if json() throws exception then response is left locked, so use responseCopy
            console.log('Error saving order guide group: ' + await responseCopy.text());
            console.log(e);
        }
    }

    assignSalesRep = (index, e) => {
        // clone arrays
        let unassignedSalesReps = this.state.unassignedSalesReps.slice(0);
        let assignedSalesReps = this.state.assignedSalesReps.slice(0);

        let salesRep = unassignedSalesReps[index];

        // remove from unassigned
        unassignedSalesReps.splice(index, 1);

        // add to assigned
        assignedSalesReps.push(salesRep);

        this.setState({ unassignedSalesReps: unassignedSalesReps, assignedSalesReps: assignedSalesReps, isDirtySalesReps: true });
    }

    unassignSalesRep = (index, e) => {
        // clone arrays
        let unassignedSalesReps = this.state.unassignedSalesReps.slice(0);
        let assignedSalesReps = this.state.assignedSalesReps.slice(0);

        let salesRep = assignedSalesReps[index];

        // remove from unassigned
        assignedSalesReps.splice(index, 1);

        // add to assigned
        unassignedSalesReps.push(salesRep);

        this.setState({ unassignedSalesReps: unassignedSalesReps, assignedSalesReps: assignedSalesReps, isDirtySalesReps: true });
    }

    assignStore = (index, e) => {
        // clone arrays
        let unassignedStores = this.state.unassignedStores.slice(0);
        let assignedStores = this.state.assignedStores.slice(0);

        let store = unassignedStores[index];

        // remove from unassigned
        unassignedStores.splice(index, 1);

        // add to assigned
        assignedStores.push(store);

        this.setState({ unassignedStores: unassignedStores, assignedStores: assignedStores, isDirtyStores: true });
    }

    unassignStore = (index, e) => {
        // clone arrays
        let unassignedStores = this.state.unassignedStores.slice(0);
        let assignedStores = this.state.assignedStores.slice(0);

        let salesRep = assignedStores[index];

        // remove from unassigned
        assignedStores.splice(index, 1);

        // add to assigned
        unassignedStores.push(salesRep);

        this.setState({ unassignedStores: unassignedStores, assignedStores: assignedStores, isDirtyStores: true });
    }

    addClicked = async (e) => {
        this.clearValidationState();
        e.preventDefault();

        if (this.state.isDirtySettings || this.state.isDirtyStores || this.state.isDirtySalesReps) {
            if (!window.confirm("Changes to this Order Guide Group will be lost. Continue?")) {
                return;
            }
        }

        await this.setState({ loading: true });
      
        await this.setState({
            editState: EditState.Add,
            orderGuideGroup: BlankOrderGuideGroup
        });

        await this.setState({ loading: false });
    }

    cancelAdd = (e) => {
        this.clearValidationState();
        e.preventDefault();
        this.componentDidMount();
    }

    // delete handling

    onDeleteClicked = (e) => {
        this.clearValidationState();
        this.setState({ showDeleteModal: true });
    }

    onDeleteModalCancel = (e) => {
        this.setState({ showDeleteModal: false });
    }

    async onDeleteModalOK(e) {
        const fetchConfig = {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        };

        let url = `api/OrderGuideGroups/delete?orderGuideGroupId=${this.state.orderGuideGroup.orderGuideGroupId}`;
        const response = await fetch(url, fetchConfig);
        try {
            if (response.ok) {
                toast.success("Order Guide Group deleted.");

                let defaultOrderGuideGroupId = await response.text();

                // update token to a different OrderGuideGroup
                const fetchConfig2 = {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                };
                const response2 = await fetch('api/Token/ChangeOrderGuideGroupClaim?orderGuideGroupId=' + defaultOrderGuideGroupId, fetchConfig2);
                if (response2.ok) {
                    const auth = await response2.json();
                    localStorage.setItem('user', JSON.stringify(auth.user));
                    localStorage.setItem('token', auth.token);

                    // update state to redirect
                    this.setState({ redirectToHome: true });
                }
                else {
                    // deleted but cannot switch, just log them off
                    toast.warn("Could not automatically switch to a different Order Guide Group. Please login again.");
                    this.props.signOut();
                }
            }
            else {
                let errorResult = await response.text();
                console.log('Error deleting order guide group: ' + errorResult);
                toast.error(errorResult);
                // json is never returned for this endpoint //this.setState({ errorResult: errorResult });
            }
        }
        catch (e) {
            console.log('Error deleting order guide group: ' + e);
        }
    }

    renderTimeLabel = (text) => (
        <span style={{ verticalAlign: 'middle', lineHeight: '35px' }}>{text}</span>
    )

    handleOrderGuideGroupDetailsFormControlChange = (e) => {
        this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, [e.target.name]: e.target.value }, isDirtySettings: true });   
    }
    // use on blur if/when typing is slow
    handleOrderGuideGroupDetailsFormControlBlur = (e) => {
        if (this.state.orderGuideGroup[e.target.name] !== e.target.value) {
            this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, [e.target.name]: e.target.value }, isDirtySettings: true });
        }
    }

    clearValidationState = () => {
        try {
            // Apparently Edge doesn't create Symbol.iterator for node lists
            // so we cannot use for-let-of, and instead must convert nodelist to an array
            let hasErrors = document.getElementsByClassName('has-error');
            if (hasErrors && hasErrors.length > 0) {
                let arrayOfErrors = Array.from(hasErrors);
                for (let i = 0; i < arrayOfErrors.length; i++) {
                    arrayOfErrors[i].classList.remove('has-error');
                }
            }
            let helpBlocks = document.getElementsByClassName('help-block');
            if (helpBlocks && helpBlocks.length > 0) {
                let arrayOfHelpBlocks = Array.from(helpBlocks);
                for (let i = 0; i < arrayOfHelpBlocks.length; i++) {
                    arrayOfHelpBlocks[i].textContent = '';
                }
            }
        }
        catch (error) {
            console.log('Error clearing validations'); console.log(error);
        }

        toast.dismiss();
        this.setState({ errorResult: undefined });
    }

    changeGuide = async (event) => {
        this.setState({ loading: true });
        const fetchConfig = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await fetch('api/Token/ChangeOrderGuideGroupClaim?orderGuideGroupId=' + event.target.value, fetchConfig);

        if (response.ok) {
            const auth = await response.json();
            localStorage.setItem('user', JSON.stringify(auth.user));
            localStorage.setItem('token', auth.token);

            try {
                const fetchConfig = {
                    method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                };
                const response = await fetch('api/OrderGuideGroups/fullsettings', fetchConfig);
                if (response.ok) {
                    let data = await response.json();

                    this.setState({
                        orderGuideGroup: data.orderGuideGroup,
                        orderGuideGroupId: data.orderGuideGroup.orderGuideGroupId,
                        assignedSalesReps: data.assignedSalesReps,
                        unassignedSalesReps: data.unassignedSalesReps,
                        assignedStores: data.assignedStores,
                        unassignedStores: data.unassignedStores,
                        loading: false,
                        editState: EditState.Edit,
                        isDirtySettings: false,
                        isDirtySalesReps: false,
                        isDirtyStores: false
                    });

                }
                else if (response.status === 401) {
                    toast.error("Unauthorized.");
                    this.props.signOut();
                }
                else {
                    toast.error(`Error fetching order guide group.`);
                    console.log(`Error fetching order guide group: ${await response.text()}.`);
                    this.setState({ redirectToHome: true });
                }
            }
            catch (error) {
                console.log("Error in changeGuide (place 3).");
                console.log(error);
            }
        }
        else {
            this.setState({ responseStatus: response.status });
        }
        this.setState({ loading: false });
    }

    sortUp = (index, e) => {
        let assignedStores = this.state.assignedStores.slice(0);
        let orderStore = assignedStores[index];
        let swapStore = assignedStores[index - 1];

        orderStore.index = index - 1;
        orderStore.sortOrder = orderStore.sortOrder - 1;
        swapStore.index = index;
        swapStore.sortOrder = swapStore.sortOrder + 1;

        assignedStores[index] = swapStore;
        assignedStores[index - 1] = orderStore;

        this.setState({ assignedStores });

        this.forceUpdate();
    }

    sortDown = (index, e) => {
        let assignedStores = this.state.assignedStores.slice(0);
        let orderStore = assignedStores[index];
        let swapStore = assignedStores[index + 1];

        orderStore.index = index + 1;
        orderStore.sortOrder = orderStore.sortOrder + 1;
        swapStore.index = index;
        swapStore.sortOrder = swapStore.sortOrder - 1;

        assignedStores[index] = swapStore;
        assignedStores[index + 1] = orderStore;

        this.setState({ assignedStores });

        this.forceUpdate();
    }

    renderManageStores = () => (
        <div>
            <hr style={{ borderTop: '1px solid gray' }} />
            <h4 style={{ paddingBottom: '20px' }}>Stores</h4>
            <Col sm={6}>
                <div className="unassignedStores" style={{ border: '1px lightgray solid', overflow: 'auto', maxHeight: '500px' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <td colSpan={2}>
                                    <label>Unassigned Stores</label>
                                </td>
                            </tr>
                            <tr>
                                <th>Code</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.unassignedStores.map((store, index) =>
                                (<tr key={index}>
                                    <td>{store.customer_Name}</td>
                                    <td><Button title="Assign" bsSize="xs" onClick={this.assignStore.bind(this, index)}><Glyphicon glyph="plus" /></Button></td>
                                </tr>)
                            )}
                        </tbody>
                        <tfoot />
                    </table>

                </div>
            </Col>
            <Col sm={6}>
                <div className="assignedStores" style={{ border: '1px lightgray solid', overflow: 'auto', maxHeight: '500px' }}>

                    <table className="table">
                        <thead>
                            <tr>
                                <td colSpan={2}>
                                    <label>Stores in {this.state.orderGuideGroup.orderGuideGroupName}</label>
                                </td>
                            </tr>
                            <tr>
                                <th>Store Name</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.assignedStores.sort(function (a, b) { return a.sortOrder - b.sortOrder; }).map((store, index) =>
                                (<tr key={index}>
                                    <td>{store.customer_Name}</td>
                                    <td>
                                        <Button title="SortUp" bsSize="xs" onClick={this.sortUp.bind(this, index)}><Glyphicon glyph="arrow-up" /></Button>
                                        <Button title="SortDown" bsSize="xs" onClick={this.sortDown.bind(this, index)}><Glyphicon glyph="arrow-down" /></Button>
                                        <Button title="Remove" bsSize="xs" onClick={this.unassignStore.bind(this, index)}><Glyphicon glyph="minus" /></Button>
                                    </td>
                                </tr>)
                            )}
                        </tbody>
                        <tfoot />
                    </table>
                </div>
            </Col>
            <Col sm={12}>
                <button type="button" className="pull-right ogcButton" onClick={this.saveStores}>Save Stores</button>
            </Col>
        </div>

    )

    renderManageSalesReps = () => (
        <div>
            <hr style={{ borderTop: '1px solid gray' }} />
            <h4 style={{ paddingBottom: '20px' }}>Sales Reps</h4>
            <Col sm={6}>
                <div className="unassignedSalesReps" style={{ border: '1px lightgray solid', overflow: 'auto', maxHeight: '500px' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <td colSpan={3}>
                                    <label>Unassigned Sales Reps</label>
                                </td>
                            </tr>
                            <tr>
                                <th>Account</th>
                                <th>Welcome Name</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.unassignedSalesReps.map((rep, index) =>
                                (<tr key={index}>
                                    <td>{rep.userName}</td>
                                    <td>{rep.name}</td>
                                    <td><Button title="Assign" bsSize="xs" onClick={this.assignSalesRep.bind(this, index)}><Glyphicon glyph="plus" /></Button></td>
                                </tr>)
                            )}
                        </tbody>
                        <tfoot />
                    </table>
                </div>
            </Col>
            <Col sm={6}>
                <div className="assignedSalesReps" style={{ border: '1px lightgray solid', overflow: 'auto', maxHeight: '500px' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <td colSpan={3}>
                                    <label>Sales Reps in {this.state.orderGuideGroup.orderGuideGroupName}</label>
                                </td>
                            </tr>
                            <tr>
                                <th>Account</th>
                                <th>Welcome Name</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.assignedSalesReps.map((rep, index) =>
                                (<tr key={index}>
                                    <td>{rep.userName}</td>
                                    <td>{rep.name}</td>
                                    <td><Button title="Remove" bsSize="xs" onClick={this.unassignSalesRep.bind(this, index)}><Glyphicon glyph="minus" /></Button></td>
                                </tr>)
                            )}
                        </tbody>
                        <tfoot />
                    </table>
                </div>
            </Col>
            <Col sm={12}>
                <button type="button" className="pull-right ogcButton" onClick={this.saveSalesReps}>Save Sales Reps</button>
            </Col>
        </div>
    )

  
    renderDetailsEditForm = () => {
        return (

            <Col sm={12}>
                <form style={{ paddingTop: '14px' }}>
                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="orderGuideGroupName" validationState={BsValidation.getFieldValidationState("orderGuideGroupName", this.state.errorResult)}>
                                <ControlLabel>Order Guide Group Name*</ControlLabel>
                                <FormControl defaultValue={this.state.orderGuideGroup.orderGuideGroupName} name="orderGuideGroupName"
                                    onBlur={this.handleOrderGuideGroupDetailsFormControlBlur}
                                />
                                <HelpBlock>{BsValidation.getFieldValidationText("orderGuideGroupName", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="emailGroupAddress" validationState={BsValidation.getFieldValidationState("emailGroupAddress", this.state.errorResult)}>
                                <ControlLabel>Group Email</ControlLabel>
                                <FormControl type='email' defaultValue={this.state.orderGuideGroup.emailGroupAddress}
                                    name='emailGroupAddress'
                                    onBlur={this.handleOrderGuideGroupDetailsFormControlBlur}
                                />
                                <HelpBlock>{BsValidation.getFieldValidationText("emailGroupAddress", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="creditEmailGroupAddress" validationState={BsValidation.getFieldValidationState("creditEmailGroupAddress", this.state.errorResult)}>
                                <ControlLabel>Credit Group Email</ControlLabel>
                                <FormControl type='email' defaultValue={this.state.orderGuideGroup.creditEmailGroupAddress}
                                    name='creditEmailGroupAddress' onBlur={this.handleOrderGuideGroupDetailsFormControlBlur}
                                />
                                <HelpBlock>{BsValidation.getFieldValidationText("creditEmailGroupAddress", this.state.errorResult)}</HelpBlock>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup controlId="OrderHoursOfOperation">
                                <ControlLabel>Next Day Order Hours</ControlLabel>
                                <Row>
                                    <Col sm={1}>{this.renderTimeLabel("Start")}</Col>
                                    <Col sm={5}>
                                        <FormGroup validationState={BsValidation.getFieldValidationState("orderHoO_Start", this.state.errorResult)}>
                                            <BsTimePickerFormControl fieldName="orderHoO_Start"
                                                onChange={this.handleOrderGuideGroupDetailsFormControlChange}
                                                value={this.state.orderGuideGroup.orderHoO_Start || ''}
                                            />
                                            <HelpBlock>{BsValidation.getFieldValidationText("orderHoO_Start", this.state.errorResult)}</HelpBlock>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={1}>{this.renderTimeLabel("End")}</Col>
                                    <Col sm={5}>
                                        <FormGroup validationState={BsValidation.getFieldValidationState("orderHoO_End", this.state.errorResult)}>
                                            <BsTimePickerFormControl fieldName="orderHoO_End"
                                                onChange={this.handleOrderGuideGroupDetailsFormControlChange}
                                                value={this.state.orderGuideGroup.orderHoO_End || ''}
                                            />
                                            <HelpBlock>{BsValidation.getFieldValidationText("orderHoO_End", this.state.errorResult)}</HelpBlock>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup controlId="OrderDayHoursOfOperation">
                                <ControlLabel>Same Day Order Hours</ControlLabel>
                                <Row>
                                    <Col sm={1}>{this.renderTimeLabel("Start")}</Col>
                                    <Col sm={5}>
                                        <FormGroup validationState={BsValidation.getFieldValidationState("sameDayOrderHoO_Start", this.state.errorResult)}>
                                            <BsTimePickerFormControl fieldName="sameDayOrderHoO_Start"
                                                onChange={this.handleOrderGuideGroupDetailsFormControlChange}
                                                value={this.state.orderGuideGroup.sameDayOrderHoO_Start || ''}
                                            />
                                            <HelpBlock>{BsValidation.getFieldValidationText("sameDayOrderHoO_Start", this.state.errorResult)}</HelpBlock>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={1}>{this.renderTimeLabel("End")}</Col>
                                    <Col sm={5}>
                                        <FormGroup validationState={BsValidation.getFieldValidationState("sameDayOrderHoO_End", this.state.errorResult)}>
                                            <BsTimePickerFormControl fieldName="sameDayOrderHoO_End"
                                                onChange={this.handleOrderGuideGroupDetailsFormControlChange}
                                                value={this.state.orderGuideGroup.sameDayOrderHoO_End || ''}
                                            />
                                            <HelpBlock>{BsValidation.getFieldValidationText("sameDayOrderHoO_End", this.state.errorResult)}</HelpBlock>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                    <div style={{ fontWeight: 'bold', marginBottom: '15px' }}>Display Settings</div>
                    {this.renderSettingsToggles()}
                </form>
                <Row>
                    <Col sm={12}>
                        {this.state.editState === EditState.Add &&
                            < button type="button" className="pull-right ogcButton" onClick={this.cancelAdd}>Cancel Add</button>
                        }
                        <button type="button" className="pull-right ogcButton" onClick={this.onDeleteClicked}>Delete Group</button>
                        <button type="button" className="pull-right ogcButton" onClick={this.saveDetails}>Save Order Group Details</button>
                    </Col>
                </Row>
            </Col>
        );
    }

    renderSettingsToggles = () => (
        <div>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showBrand || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showBrand: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Brand</ControlLabel>
                </FormGroup>
            </Col>
            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showComments || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showComments: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Comments</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showIncoming || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showIncoming: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Incoming</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showPastDelivery || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showPastDelivery: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Past Delivery</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showPricing || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showPricing: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Pricing</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showShortCode || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showShortCode: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Short Code</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showStoreComments || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showStoreComments: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Store Comments</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='Hide'
                            activeLabel='Show'
                            value={this.state.orderGuideGroup.showTotalOrder || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showTotalOrder: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Total Order</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.useNWSProducts || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, useNWSProducts: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Use NSW Products</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.useNWSRules || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, useNWSRules: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Use NSW Rules</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.allowMultipleDayOrderGuide || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, allowMultipleDayOrderGuide: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Multiple Day Guide</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.allowSameDayDeliveries || false}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, allowSameDayDeliveries: !value }, isDirtySettings: true });
                            }}
                        />
                    </div>
                    <ControlLabel>Same Day Deliveries</ControlLabel>
                </FormGroup>
            </Col>

            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.showGroupBuyerNotes}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, showGroupBuyerNotes: !value } });
                            }}
                        />
                    </div>
                    <ControlLabel>Group Buyer Notes</ControlLabel>
                </FormGroup>
            </Col>
            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.allowAutoUpdateOrders}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, allowAutoUpdateOrders: !value } });
                            }}
                        />
                    </div>
                    <ControlLabel>Auto Update Orders</ControlLabel>
                </FormGroup>
            </Col>
            <Col sm={4}>
                <FormGroup>
                    <div style={{ display: 'inline-block', marginRight: '10px' }}>
                        <ToggleButton
                            inactiveLabel='No'
                            activeLabel='Yes'
                            value={this.state.orderGuideGroup.lockOriginalLineAfterSub}
                            onToggle={(value) => {
                                this.setState({ orderGuideGroup: { ...this.state.orderGuideGroup, lockOriginalLineAfterSub: !value } });
                            }}
                        />
                    </div>
                    <ControlLabel>Lock Original Line After Sub </ControlLabel>
                </FormGroup>
            </Col>
        </div>
    )

    render() {
        if (!this.props.isAuthenticated) {
            return (
                <Redirect to="/login" />
            );
        }

        if (this.state.redirectToHome) {
            return (
                <Redirect to="/" />
            );
        }

        return (
            <div>
                <PageHeader pageTitle="Order Guide Group"
                    pageHeaderRight={
                        <PageHeaderRight>
                            {!this.state.loading &&
                                <GroupDropdown onChange={this.changeGuide}
                                    value={this.state.orderGuideGroupId}
                                    name="orderGuideGroupId"
                                />
                            }
                            <button className="ogcButton btn-std-size" type="button" onClick={this.addClicked.bind(this)}>Add</button>
                        </PageHeaderRight>
                    }
                />
                {this.state.errorResult && this.state.errorResult.errorSummary &&
                    <Col sm={12}>
                        <FormGroup validationState={"error"}>
                            <HelpBlock>{this.state.errorResult.errorSummary}</HelpBlock>
                        </FormGroup>
                    </Col>
                }
                {this.state.loading ? (
                    <p style={{ padding: '10px' }}><em>Loading...</em></p>
                ) :
                    (
                        this.renderDetailsEditForm()
                    )}

                {!this.state.loading && this.state.editState === EditState.Edit &&
                    <div>
                        <Col sm={12}>
                            {this.renderManageSalesReps()}
                        </Col>
                        <Col sm={12}>
                            {this.renderManageStores()}
                        </Col>
                    </div>
                }

                {<ModalOKCancel
                    title="Delete Order Guide Group"
                    body={`Delete ${this.state.orderGuideGroup.orderGuideGroupName}?`}
                    show={this.state.showDeleteModal}
                    onOK={this.onDeleteModalOK.bind(this)}
                    onCancel={this.onDeleteModalCancel.bind(this)}
                 />
                }

                <Prompt when={this.state.isDirtySettings || this.state.isDirtyStores || this.state.isDirtySalesReps}
                    message="Changes to the this Order Guide Group will be lost. Continue?"
                />
            </div >
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderGuideGroup));



// WEBPACK FOOTER //
// ./src/components/Admin/OrderGuideGroup.js